import controller from './file-preview-multiple-modal.controller';
import template from './file-preview-multiple-modal.html';
import './file-preview-multiple-modal.scss';
import '../../../../components/kform/tab-file-multiple/kform-tab-file-multiple.scss';

/**
 * @param {any} resolve
 * @returns {any}
 */
export default ({ resolve }) => ({
	template,
	resolve,
	controller,
	controllerAs: '$ctrl',
	size:         'full',
});
